import { IBusinessState } from '@/@types'

const state: IBusinessState = {
  businessUser: null,
}

export default state
